module.exports = __webpack_public_path__ + "static/media/display06.38ba3f66.jpg";